import AuthRequired from "./utils/AuthRequired";
import AuthRole from "./utils/AuthRole";

export default [
    {
        path: '/',
        component: () => import('./views/EmptySiteName'),
      },
      {
        path: '/:sitename/user',
        component: () => import('./views/user'),
        redirect: '/:sitename/user/login',
        children: [
          {path: 'login/:id?', component: () => import('./views/user/Login')},
          {path: 'passLogin', component: () => import('./views/user/Login')},
          {path: 'register', component: () => import('./views/user/Register')},
          {path: 'forgot-password/:id?', component: () => import('./views/user/ForgotPassword')},
          {path: 'forgot-id/:id?', component: () => import('./views/user/ForgotId')},
          {path: 'change-sitename', component: () => import('./views/ChangeSiteName')},
          {path: 'findId', component: () => import('./views/user/FindIdSuccess')},
          {path: 'findPass', component: () => import('./views/user/FindPasswordSuccess')},
          {path: 'service', component: () => import('./views/user/service')},
          {path: 'privacy', component: () => import('./views/user/privacy')},
        ]
      },
      {
        path: '/:sitename',
        component: () => import('./views/app'),
        redirect: '/:sitename/booking',
        beforeEnter: AuthRequired,
        children: [
          // {
          //   path: 'dashboard',
          //   component: () => import('./views/dashboard'),
          //   redirect: '/:sitename/dashboard/running-status',
          //   children: [
          //     { path: 'running-status', component: () => import('./views/dashboard/RunningStatus') }
          //   ]
          // },
          {
            path: 'booking',
            component: () => import('./views/booking'),
            redirect: '/:sitename/booking/booking-visit',
            children: [
              {path: 'booking-status', component: () => import('./views/booking/BookingStatusList')},
              {path: 'booking-visit', component: () => import('./views/booking/BookingVisitList')},
              {path: 'booking-request', component: () => import('./views/booking/BookingRequestList')},
              {path: 'booking-cancel', component: () => import('./views/booking/BookingCancellation')},
              {path: 'booking-unvisited', component: () => import('./views/booking/BookingUnvisitedList')},
              {path: 'booking-calendar', component: () => import('./views/booking/BookingCalendar')},
              {path: 'booking-call-reservation', component: () => import('./views/booking/CallReservation')}
            ]
          },
          {
            path: 'order',
            component: () => import('./views/order'),
            redirect: '/:sitename/order/order-search',
            children: [
              {path: 'order-search', component: () => import('./views/order/OrderSearch')},
              {path: 'order-detail/:order_no', component: () => import('./views/order/OrderDetail' )},
              {path: 'order-cancellantion', component: () => import('./views/order/OrderCancellationRequest')},
              {path: 'evidence-request', component: () => import('./views/order/OrderEvidenceRequest')},
              {path: 'order-list', component: () => import('./views/order/OrderList')},
            ]
          },
          {
            path: 'goods',
            component: () => import('./views/goods'),
            redirect: '/:sitename/goods/goods-list',
            children: [
              {path: 'goods-list', component: () => import('./views/goods/RunningGoodsList')},
              {path: 'goods-register-status', component: () => import('./views/goods/GoodsRegisterStatus')},
              {path: 'goods-edit-request/:goodsId', component: () => import('./views/goods/GoodsRegisterRequest')},
              {path: 'goods-register-request/:registerId?', component: () => import('./views/goods/GoodsRegisterRequest')},
              {path: 'goods-copy-request/:copyGoodsId', component: () => import('./views/goods/GoodsRegisterRequest')}, //상품리스트 복사
              {
                path: 'goods-copy-register-request/:copyRegisterId',
                component: () => import('./views/goods/GoodsRegisterRequest')
              },//신규상품복사
              {
                path: 'representative-option/:registerId',
                component: () => import('./views/goods/GoodsRepresentativeOption')
              },
              {path: 'individual-option/:registerId', component: () => import('./views/goods/GoodsIndividualOption')},
            ]
          },
          {
            path: 'shop',
            component: () => import('./views/shop'),
            redirect: '/:sitename/shop/shop-list',
            children: [
              {path: 'shop-list', component: () => import('./views/shop/RunningShopList')},
              {path: 'edit-shop/:storeCode', name: 'edit-shop', component: () => import('./views/shop/EditRunningShop')},
              {path: 'shop-register-status', component: () => import('./views/shop/ShopRegisterStatus'),beforeEnter:AuthRole},
              {
                path: 'shop-register-request/:storeCode?',
                // name: "shop-register",
                component: () => import('./views/shop/ShopRegisterRequest')
              },
              {path: 'AlimtalkMng', component: () => import('./views/shop/AlimtalkMng')},
              {path: 'AlimtalkReg', component: () => import('./views/shop/components/AlimtalkReg')},
            ]
          },
          {
            path: 'coupon',
            component: () => import('./views/sales'),
            redirect: '/:sitename/coupon/coupon-search',
            children: [
              {path: 'coupon-search/:searchKind?/:searchKeyword?', component: () => import('./views/coupon/CouponSearch')},
            ]
          },
          {
            path: 'sales',
            component: () => import('./views/sales'),
            redirect: '/:sitename/sales/sales-status',
            children: [
              {path: 'sales-amount', component: () => import('./views/sales/SalesAmount')},
              {path: 'sales-status', component: () => import('./views/sales/SalesStatus')},
              {path: 'settlement-status', component: () => import('./views/sales/SettlementStatus')}
            ]
          },
          {
            path: 'manager',
            component: () => import('./views/manager'),
            redirect: '/:sitename/manager/manager-list',
            children: [
              {path: 'manager-list', component: () => import('./views/manager/ManagerList')},
              {path: 'manager-detail/:id', component: () => import('./views/manager/ManagerDetail')},
              {path: 'register-detail/:id', component: () => import('./views/manager/ManagerDetail')},
              {path: 'register-new-manager', component: () => import('./views/manager/RegisterNewManager')},
              {path: 'general-member', component: () => import('./views/manager/GeneralMember')},
              {path: 'general-detail/:id', component: () => import('./views/manager/GeneralDetail')},
            ]
          },
          {
            path: 'member',
            component: () => import('./views/shop'),
            redirect: '/:sitename/member/user-list',
            children: [
              {path: 'user-list', component: () => import('./views/member/UserList')},
              {path: 'user-reviews', component: () => import('./views/member/UserReviews')},
              {path: 'user-detail/:id', component: () => import('./views/member/UserDetail')},
              {path: 'user-modify', component: () => import('./views/member/UserModify.vue')},
            ]
          },
          {
            path: 'statistics',
            component: () => import('./views/statistics'),
            redirect: '/:sitename/statistics/report',
            children: [
              {path: 'report', component: () => import('./views/statistics/Report')},
              {path: 'penalty', component: () => import('./views/statistics/Penalty')},
            ]
          },
          {
            path: 'notice',
            component: () => import('./views/notice'),
            redirect: '/:sitename/notice/NoticeList',
            children: [
              {path: 'NoticeList', component: () => import('./views/notice/NoticeList')},
              {path: 'NoticeDetail', component: () => import('./views/notice/NoticeDetail')},
            ]
          }

          ,
          {
            path: 'siteSet',
            component: () => import('./views/siteSet'),
            redirect: '/:sitename/siteSet/SiteSetDetail',
            children: [
              {path: 'SiteSetDetail', component: () => import('./views/siteSet/SiteSetDetail')},
              {path: 'AlimtalkMng', component: () => import('./views/siteSet/AlimtalkMng')},
              {path: 'AlimtalkReg', component: () => import('./views/siteSet/components/AlimtalkReg')},
            ]
          }
          ,
          {
            path: 'sendmessage',
            component: () => import('./views/sendMessage'),
            redirect: '/:sitename/sendMessage/messageSend',
            children: [
              {path: 'messageSend', component: () => import('./views/sendMessage/messageSend')},
              {path: 'messageSent', component: () => import('./views/sendMessage/messageSent')},
            ]
          }

        ]
      },
      {path: '/error', component: () => import('./views/Error')},
      {path: '*', component: () => import('./views/Error')},
      {path: '/mobile/error', component: () => import('./views/MobileError'), meta: {flag: true}},
      {path: '/ip/error', component: () => import('./views/IpError'), meta:{flag1: true}}
]
